<div class="p-1">
    <div class="row">
      <div class="col-md-12">
        <a *ngIf="currentLease && checkPreviousLease" class="badge badge-success me-2 float-end c-pointer" (click)="changeLeases()">Previous Leases</a>
        <a *ngIf="!currentLease" class="badge badge-success me-2 float-end c-pointer" (click)="changeLeases()">Current Lease</a>
        <a *ngIf="checkAddLease" class="badge badge-primary me-2 float-end c-pointer" (click)="addLeaseModal()">New Lease</a>
      </div>
    </div>
    <div class="row ps-2 mt-2">
      <div class="col-xl-12">
        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
    <table id="empoloyees-tbl" class="table mb-0">
        <thead>
          <tr>
            <th>Lease/Rent</th>
            <th>Security Deposit</th>
            <th>Lease Start Date</th>
            <th>Lease End Date</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let document of property_leases">
            <td>
              {{ document.lease_amount }}
            </td>
            <td>
              {{ document.security_deposit }}
            </td>
            <td>
              {{ document.start_date | date:'dd-MM-yyyy' }}
            </td>
            <td>
              {{ document.end_date | date:'dd-MM-yyyy' }}
            </td>

              <td>
                <div class="img-wrapper" *ngIf="checkViewLease">
                  <button class="btn btn-info shadow btn-xs sharp me-2" data-bs-dismiss="offcanvas" data-bs-target="#view_lease"  (click)="viewLeaseToggle(document)">
                    <i class="fa fa-eye"></i>
                  </button>
                  <div class="tooltip-text">View</div>
                </div>
                <div class="img-wrapper" *ngIf="currentLease && checkEditLease">
                  <button class="btn btn-success shadow btn-xs sharp me-2" (click)="viewLease(document.uid)"><i class="fa fa-edit"></i></button>
                  <div class="tooltip-text">Edit</div>
                </div>
                <div class="img-wrapper" *ngIf="currentLease && checkRenewLease">
                  <button class="btn btn-primary shadow btn-xs sharp me-2" (click)="renewLease(document.uid)">
                    <i class="fa fa-refresh"></i>
                  </button>
                  <div class="tooltip-text">Renew</div>
                </div>
                <div class="img-wrapper" *ngIf="currentLease && checkArchiveLease">
                  <button class="btn btn-danger shadow btn-xs sharp me-2" (click)="archiveLease(document.uid)"><i class="fa fa-archive"></i></button>
                  <div class="tooltip-text">Archive</div>
                </div>
              </td>
          </tr>
        </tbody>
        </table>
        </div></div>
</div>
</div>


<div #addLeaseButton class="offcanvas offcanvas-end customeoff {{ add_lease ? 'show':''}}" tabindex="-1" id="add_lease"  data-bs-backdrop="static">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">{{ isEditLease ? 'Edit' : 'Add'}} Lease</h5>
      <button type="button" class="btn-close" (click)="addLeaseClose()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="addLeaseForm" (ngSubmit)="addLease()" autocomplete="off">

        <div class="row">
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Lease/Rent Amount<span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Lease/Rent"
              formControlName="lease_amount">
            <div *ngIf="addLeaseForm?.get('lease_amount')?.invalid && addLeaseForm?.get('lease_amount')?.touched"
              class="required">
              Lease/Rent Amount is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Security Deposit<span
                class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Security Deposit"
              formControlName="security_deposit">
            <div *ngIf="addLeaseForm?.get('security_deposit')?.invalid && addLeaseForm?.get('security_deposit')?.touched"
              class="required">
              Security Deposit is required
            </div>
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Rental Agreement Date<span
                class="text-danger">*</span></label>
            <input type="date" class="form-control" id="exampleFormControlInput1-1" placeholder="Rental Agreement Date" formControlName="agreement_date">
            <div *ngIf="addLeaseForm?.get('agreement_date')?.invalid && addLeaseForm?.get('agreement_date')?.touched"
              class="required">
              Rental Agreement Date is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Tenant Moving In Date</label>
            <input type="date" class="form-control" id="exampleFormControlInput1-1" placeholder="Rental Agreement Date "
              formControlName="in_date">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Tenant Moving Out Date</label>
            <input type="date" class="form-control" id="exampleFormControlInput1-1" placeholder="Rental Agreement Date " formControlName="out_date" [min]="addLeaseForm.get('in_date')?.value">
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Lease Start Date<span
                class="text-danger">*</span></label>
            <input type="date" class="form-control" id="exampleFormControlInput1-1" placeholder="Rental Agreement Date "
              formControlName="start_date">
            <div *ngIf="addLeaseForm?.get('start_date')?.invalid && addLeaseForm?.get('start_date')?.touched"
              class="required">
              Lease Start Date is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Lease End Date<span
                class="text-danger">*</span></label>
            <input type="date" class="form-control" id="exampleFormControlInput1-1" placeholder="Rental Agreement Date " formControlName="end_date" [min]="addLeaseForm.get('start_date')?.value">
            <div *ngIf="addLeaseForm?.get('end_date')?.invalid && addLeaseForm?.get('end_date')?.touched" class="required">
              Lease End Date is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Leaving Reason</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Leaving Reason" formControlName="leaving_reason">

          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Rent Yearly Increment(%)</label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="123"
              formControlName="yearly_increment">
            <!-- <div *ngIf="addLeaseForm?.get('yearly_increment')?.invalid && addLeaseForm?.get('yearly_increment')?.touched" class="required">
            Lease Yearly Increment is required
        </div>  -->
          </div>

          <div class="col-xl-12 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Select Tenants<span
                class="text-danger">*</span></label>
            <ng-select [items]="allTenants" bindLabel="fullName" bindValue="uid" formControlName="tenants" [multiple]="true"
              [searchable]="true" placeholder="search for tenants" [typeahead]="searchInput$" [virtualScroll]="true" (scrollToEnd)="onScrollToEnd()">
            </ng-select>
            <div *ngIf="addLeaseForm?.get('tenants')?.invalid && addLeaseForm?.get('tenants')?.touched" class="required">
              Select atleast one tenant
            </div>
          </div>

          <div class="col-xl-12 mt-2" *ngIf="isEditLease && addLeaseForm.get('document_url')?.value">
          <span class="fs-13 mb-3">Lease Document</span>
            <div class="row">
              <div class="col-md-6">
                <p class="badge light badge-light"> {{ addLeaseForm.get('document_url')?.value }} </p>
              </div>
              <div class="col-md-6">
                <p class="badge light badge-primary me-3 ms-4 c-pointer float-end" (click)="viewImage(addLeaseForm.get('document_url')?.value)"> View </p>
              </div>
            </div>
        </div>

        </div>
        <div class="">
          <label>Lease Document<span class="text-danger">*</span></label>
          <div class="dz-default dlab-message upload-img mb-3">
            <div class="dropzone">
              <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M20.5 20V35" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M34.4833 30.6501C36.1088 29.7638 37.393 28.3615 38.1331 26.6644C38.8731 24.9673 39.027 23.0721 38.5703 21.2779C38.1136 19.4836 37.0724 17.8926 35.6111 16.7558C34.1497 15.619 32.3514 15.0013 30.4999 15.0001H28.3999C27.8955 13.0488 26.9552 11.2373 25.6498 9.70171C24.3445 8.16614 22.708 6.94647 20.8634 6.1344C19.0189 5.32233 17.0142 4.93899 15.0001 5.01319C12.9861 5.0874 11.015 5.61722 9.23523 6.56283C7.45541 7.50844 5.91312 8.84523 4.7243 10.4727C3.53549 12.1002 2.73108 13.9759 2.37157 15.959C2.01205 17.9421 2.10678 19.9809 2.64862 21.9222C3.19047 23.8634 4.16534 25.6565 5.49994 27.1667"
                  stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <div class="fallback">

                <input name="file" type="file" accept=".pdf,.doc" (change)="onImageChange($event)">

              </div>
            </div>
          </div>
          <div *ngIf="addLeaseForm.get('lease_document')?.errors?.['fileRequired'] && addLeaseForm?.get('lease_document')?.touched" class="required">
              Lease Document is required
          </div>
        </div>
        <div>
          <button *ngIf="checkAddLease" class="btn btn-primary ms-1 me-3" type="submit"
            [disabled]="addLeaseForm.invalid || loadingService.isLoading()">Submit</button>
          <button class="btn btn-danger lightme-1 float-end" type="button" (click)="addLeaseClose()">Close</button>
        </div>
      </form>
        </div>
    </div>
  </div>
  @if(add_lease){
    <div class="offcanvas-backdrop fade show" (click)="addLeaseModal()"></div>
  }

  <div class="offcanvas offcanvas-end customeoff {{ view_lease ? 'show':''}}" tabindex="-1" id="view_lease"  data-bs-backdrop="static" *ngIf="viewLeaseDetails && checkViewLease">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">View Lease</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"  (click)="viewLeaseToggle('')">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >

        <div class="row">
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Lease/Rent Amount</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.lease_amount}}</span>
          </div>
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Security Deposit</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.security_deposit}}</span>
          </div>

          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Rental Agreement Date</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.agreement_date | date:'dd-MM-yyyy'}}</span>
          </div>
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Tenant Moving In Date</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.in_date | date:'dd-MM-yyyy'}}</span>
          </div>
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Tenant Moving Out Date</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.out_date | date:'dd-MM-yyyy'}}</span>
          </div>
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Lease Start Date</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.start_date | date:'dd-MM-yyyy'}}</span>
          </div>
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Lease End Date</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.end_date | date:'dd-MM-yyyy'}}</span>
          </div>
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Leaving Reason</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.leaving_reason}}</span>

          </div>
          <div class="col-xl-4 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Rent Yearly Increment(%)</label>
            <span class="fs-13 text-secondary fw-semibold ms-3">{{viewLeaseDetails.yearly_increment}}</span>
          </div>


          <div class="col-xl-12 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Tenants</label>
            <div class="mt-1 d-flex " >
                  <div class="m-1" *ngFor="let tenant of viewLeaseDetails.tenants">
                    <div class="las la-user p-1 btn-block">  {{ tenant.first_name  }} {{ tenant?.last_name }} </div>
                    <div class="las la-envelope p-1 btn-block">  {{ tenant.email }} </div>
                    <div class="las la-phone p-1 btn-block">  {{ tenant.phone }} </div>
                  </div>
            </div>
          </div>

        </div>
        <div class="col-xl-12 mt-2" *ngIf="viewLeaseDetails.document_url">
          <span class="fs-13 mb-3">Lease Document</span>
            <div class="row">
              <div class="col-md-6">
                <p class="badge light badge-light"> {{ viewLeaseDetails.document_url }} </p>
              </div>
              <div class="col-md-6">
                <p class="badge light badge-primary me-3 ms-4 c-pointer" (click)="viewImage(viewLeaseDetails.document_url)"> View </p>
              </div>
            </div>
        </div>
        <div>
          <button class="btn btn-danger lightme-1 float-end" type="button" data-bs-dismiss="offcanvas" aria-label="Close"
            (click)="viewLeaseToggle('')">Close</button>
        </div>
        </div>
    </div>
  </div>
  @if(view_lease){
    <div class="offcanvas-backdrop fade show" (click)="viewLeaseToggle('')"></div>
  }
